import { atom } from 'recoil';

const returnedPostCountAtom = atom({
    key: 'returnedPostCount',
    default: 0
});

export {
    returnedPostCountAtom
};